import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpimprichichwad() {



  const cardData =
  {
    keyword: 'Urbania On Rent in Pimpri Chinchwad',
    heading: 'Amruta Travels: Urbania On Rent in Pimpri Chinchwad',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Urbania on Rent in Pimpri Chinchwad, delivering a luxurious and comfortable travel experience for families, corporate clients, and group travelers. Our Force Urbania vans are ideal for airport transfers, corporate meetings, weddings, family trips, and outstation journeys, ensuring a smooth and stylish ride every time. Each vehicle features spacious interiors, push-back seats, strong air conditioning, and ample luggage space for a relaxed journey. With professional chauffeurs ensuring safety, punctuality, and courteous service, Amruta Travels’ Urbania Rental in Pimpri Chinchwad is the trusted choice across Nigdi, Chinchwad, Wakad, Hinjewadi, and Talegaon for travelers who demand comfort, luxury, and reliability in every trip.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical landmark. Once the royal residence of the Maratha Empire, the fort showcases grand architecture, massive gates, and an aura of regal heritage. The evening light and sound show vividly brings its glorious history to life. Shaniwar Wada remains a proud symbol of Pune’s cultural and royal legacy."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is one of Pune’s most majestic and historically significant buildings. It served as a prison for Mahatma Gandhi and Kasturba Gandhi during the Quit India Movement. The palace’s beautiful architecture and well-maintained gardens create a peaceful atmosphere. Today, it stands as a national monument celebrating India’s freedom struggle."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched high in the Sahyadri ranges, is known for its breathtaking views and valiant history. It was the site of the famous battle where Tanaji Malusare fought heroically for Chhatrapati Shivaji Maharaj. The fort’s rugged pathways, ancient walls, and surrounding greenery make it a popular trekking destination. Sinhagad is Pune’s living monument to Maratha bravery."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dedicated to Lord Ganesha, the Dagdusheth Halwai Ganpati Temple is Pune’s most revered place of worship. The gold-plated idol and intricate decorations attract devotees from across the nation. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations. This spiritual landmark symbolizes Pune’s devotion, culture, and unity."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers a serene escape within Pune, with stunning views of the city skyline. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa reign. Visitors enjoy the peaceful climb of 108 steps and the panoramic view at the top. Parvati Hill blends heritage, faith, and scenic charm in perfect harmony."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved out of basalt rock in the 8th century, the Pataleshwar Cave Temple is a masterpiece of ancient Indian architecture. Dedicated to Lord Shiva, it features a circular Nandi mandapa and beautifully sculpted pillars. Located in the heart of Pune, it offers a tranquil environment for meditation. Pataleshwar reflects the city’s spiritual and historical depth."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses a vast collection of over 20,000 artifacts from India’s cultural past. From musical instruments and sculptures to household items, every exhibit tells a story of heritage. Founded by Dr. D.G. Kelkar, the museum offers a fascinating journey through history. It is one of Pune’s finest cultural and educational attractions."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for wellness and spirituality. Surrounded by lush gardens, it offers meditation sessions, therapy programs, and a peaceful retreat from urban chaos. Visitors from around the world come to rejuvenate their mind and body. Osho Ashram represents Pune’s modern, cosmopolitan, and spiritual identity."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just a short drive from Pune, is a picturesque spot surrounded by green hills and calm waters. It’s a favorite picnic destination where visitors enjoy street food, photography, and evening walks. The scenic sunsets over the reservoir are truly mesmerizing. Khadakwasla offers Pune residents a refreshing escape into nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s Korakuen Garden, the Pune Okayama Friendship Garden is a beautifully landscaped park symbolizing peace and harmony. With flowing streams, manicured lawns, and traditional bridges, it offers a tranquil atmosphere for relaxation. Families and couples enjoy leisurely walks amid its serene surroundings. The garden is Pune’s celebration of friendship and global culture."
  }
],



       "services": [
    {
      "name": "Urbania On Rent in Pimpri Chinchwad",
      "description": "Urbania On Rent in Pimpri Chinchwad offers premium and comfortable travel for families, corporates, and tourists within the PCMC area and beyond. Each Force Urbania is equipped with plush seating, ample legroom, and advanced air conditioning for an effortless travel experience. Whether it’s a one-day city trip or a weekend outing to nearby destinations like Lonavala or Mahabaleshwar, this service ensures punctuality and safety. The fleet is maintained regularly, guaranteeing reliability for every journey. Professional drivers with excellent route knowledge make travel smoother and stress-free. Customers can enjoy 24/7 booking, flexible packages, and affordable pricing tailored for every need. From weddings to corporate trips, this Urbania rental ensures luxury and comfort for every group size."
    },
    {
      "name": "Urbania Hire Pimpri Chinchwad",
      "description": "Urbania Hire Pimpri Chinchwad provides high-quality travel options for residents and businesses across PCMC, including Nigdi, Bhosari, and Wakad. Ideal for both short city commutes and long outstation trips, these vehicles feature comfortable push-back seats, air conditioning, and large storage capacity. The service focuses on delivering timely, safe, and professional transport solutions. Experienced drivers ensure smooth navigation through Pimpri’s busy streets and highways. Customers can choose from AC, Non-AC, and luxury variants depending on their budget and preference. With transparent rates, clean interiors, and prompt customer support, Urbania Hire Pimpri Chinchwad stands out as the most dependable rental choice in the region."
    },
    {
      "name": "Force Urbania Rental Pimpri Chinchwad",
      "description": "Force Urbania Rental Pimpri Chinchwad offers a fleet of modern, comfortable, and well-maintained vans suited for group travel, corporate tours, and family vacations. Each Urbania includes advanced safety features, smooth suspension, and spacious interiors to ensure a relaxing journey. The service caters to all types of clients, from small families to large corporate teams. Drivers are trained professionals familiar with both local and outstation routes. Whether you need a one-way ride, full-day hire, or weekend package, flexible booking options make it easy to plan your journey. With competitive pricing and round-the-clock support, this rental ensures the perfect blend of luxury, reliability, and affordability."
    },
    {
      "name": "AC Urbania Pimpri",
      "description": "AC Urbania Pimpri provides a refreshing and comfortable travel experience for both local and long-distance journeys. Equipped with efficient air conditioning, clean upholstery, and push-back seating, this service is designed for passengers who value comfort in every kilometer. It’s perfect for corporate meetings, airport transfers, and weekend getaways. Drivers are courteous and experienced, ensuring smooth travel through city traffic and highways. The vehicles are regularly sanitized and maintained for safety and hygiene. Affordable pricing, flexible packages, and punctual service make AC Urbania Pimpri a preferred choice for families, professionals, and event organizers alike."
    },
    {
      "name": "Non AC Urbania Pimpri",
      "description": "Non AC Urbania Pimpri offers a practical, budget-friendly solution for short trips and daily travel across PCMC. The vehicles are spacious, clean, and comfortable, ensuring passengers travel safely without compromising on reliability. Perfect for school excursions, local sightseeing, and quick commutes, this service focuses on affordability and punctuality. Each driver is courteous and skilled in navigating local routes. With transparent rates, flexible timings, and a customer-first approach, Non AC Urbania Pimpri provides dependable transport for groups who prefer cost-effective yet comfortable travel options."
    },
    {
      "name": "Luxury Urbania Pimpri",
      "description": "Luxury Urbania Pimpri brings elegance and sophistication to every journey, offering high-end vehicles with plush interiors and premium amenities. These Urbanias feature leather seats, LED lighting, and advanced climate control systems to deliver an executive-class experience. Ideal for VIP transfers, weddings, and corporate events, this service combines comfort and style. Drivers are uniformed, courteous, and trained for professional service. The vehicles undergo regular maintenance to ensure perfection at every level. With flexible packages and personalized service, Luxury Urbania Pimpri guarantees a luxurious travel experience for every passenger."
    },
    {
      "name": "16 Seater Urbania Pimpri",
      "description": "16 Seater Urbania Pimpri is the perfect solution for small to medium-sized groups seeking safe and convenient travel. Each vehicle offers cushioned seats, air conditioning, and modern safety features for a pleasant journey. It’s an ideal choice for school trips, family outings, and business travel. Drivers are punctual and well-versed with local and intercity routes. Customers enjoy flexible rental options, affordable pricing, and 24/7 customer support. With clean, well-maintained interiors and excellent ride comfort, this 16-seater Urbania ensures a smooth and memorable group travel experience in and around Pimpri Chinchwad."
    },
    {
      "name": "17 Seater Urbania Pimpri",
      "description": "17 Seater Urbania Pimpri provides ample space, comfort, and reliability for larger groups traveling for leisure or business. The vehicle’s ergonomic design includes plush seats, air conditioning, and extra luggage space, making it ideal for corporate events, family tours, or pilgrimages. The service ensures smooth, timely rides with experienced drivers who prioritize passenger safety. Customers can choose from multiple rental durations, including hourly, daily, and outstation packages. Regular vehicle servicing and 24-hour customer support add to its dependability. Whether within Pune or to nearby tourist spots, the 17 Seater Urbania Pimpri guarantees premium travel at competitive rates."
    },
    {
      "name": "Urbania Hire in Nigdi",
      "description": "Urbania Hire in Nigdi offers reliable, comfortable, and affordable mini-bus rentals tailored for both local and long-distance journeys. Perfect for group tours, weddings, or corporate outings, these vehicles provide air-conditioned interiors, soft seats, and ample space for luggage. Drivers are punctual and courteous, ensuring smooth travel experiences across Pune and Maharashtra. The service provides flexible booking durations, competitive rates, and easy online reservations. Whether it’s a one-day trip to Lonavala or a multi-day pilgrimage, Urbania Hire in Nigdi delivers seamless, safe, and enjoyable travel for all passengers."
    },
    {
      "name": "Urbania Hire in Wakad",
      "description": "Urbania Hire in Wakad serves the growing residential and corporate community with high-quality Urbania rental services. The fleet includes AC, Non-AC, and luxury models suitable for all types of group travel. Passengers enjoy smooth rides with professional drivers familiar with city traffic and long routes. Each vehicle is regularly inspected and sanitized to maintain safety standards. Ideal for office teams, weddings, and family getaways, the service ensures punctual, comfortable, and reliable travel. With flexible packages and excellent customer care, Urbania Hire in Wakad redefines convenient transportation for PCMC travelers."
    },
    {
      "name": "Urbania Hire in Bhosari",
      "description": "Urbania Hire in Bhosari offers dependable mini-bus rentals designed for industrial, family, and business travel needs. The vehicles are spacious, well-ventilated, and equipped with comfortable seating for stress-free journeys. Perfect for daily commutes, factory visits, or outstation tours, this service combines comfort with affordability. Experienced drivers ensure safe and timely travel, while flexible rental options cater to varying schedules. Clean interiors, transparent pricing, and responsive customer support make this service a trusted choice among Bhosari’s residents and businesses for reliable Urbania transport."
    },
    {
      "name": "Corporate Urbania Pimpri",
      "description": "Corporate Urbania Pimpri offers premium transportation solutions for businesses across PCMC. Designed for professionals and office teams, these vehicles provide comfortable seating, Wi-Fi availability, and air conditioning for a productive commute. Ideal for daily transfers, conferences, or team off-sites, the service focuses on punctuality and reliability. Chauffeurs are trained to provide courteous and efficient service while adhering to strict schedules. With flexible corporate packages and long-term rental plans, companies can ensure hassle-free mobility for employees and guests. It’s a blend of comfort, professionalism, and dependability for corporate travel needs."
    },
    {
      "name": "Wedding Urbania Pimpri",
      "description": "Wedding Urbania Pimpri ensures that your special day is celebrated with comfort and elegance. The service offers beautifully maintained Urbanias for family and guest transfers during wedding events. Vehicles can be decorated as per the theme and feature air conditioning, music systems, and soft lighting to create a festive atmosphere. Drivers are punctual and courteous, ensuring timely arrivals at each function. From mehndi ceremonies to receptions, this service handles guest transport efficiently. With clean interiors, flexible bookings, and personalized service, Wedding Urbania Pimpri adds luxury and reliability to your celebration."
    },
    {
      "name": "Outstation Urbania Pimpri",
      "description": "Outstation Urbania Pimpri specializes in long-distance group travel, connecting PCMC to top destinations like Goa, Mahabaleshwar, and Shirdi. The vehicles offer excellent seating comfort, AC options, and large luggage capacity for multi-day journeys. Drivers are well-trained in highway and hill-route navigation, ensuring safety and punctuality. Customers can select one-way or round-trip rentals with customized itineraries. Cleanliness, reliability, and 24-hour support make this the go-to choice for families, corporates, and tourists. Outstation Urbania Pimpri delivers a perfect mix of comfort, convenience, and value for every long trip."
    },
    {
      "name": "Affordable Urbania Pimpri Chinchwad",
      "description": "Affordable Urbania Pimpri Chinchwad is designed for budget-conscious travelers who still want premium service. The vehicles are well-maintained, spacious, and ideal for family trips, school outings, and office tours. Despite its affordable rates, the service maintains high standards of safety, hygiene, and punctuality. Flexible rental durations, easy booking, and courteous drivers make it convenient for every traveler. Whether for short trips within the city or long outstation journeys, this service offers exceptional value without compromising comfort or reliability."
    },
    {
      "name": "Urbania Hire near Me Pimpri",
      "description": "Urbania Hire near Me Pimpri makes it easy for residents and businesses in PCMC to access top-quality mini-bus rentals nearby. The service ensures quick response times, flexible pickup points, and professional drivers. Each vehicle is equipped with air conditioning, clean interiors, and comfortable seats for short or long journeys. Customers can instantly book via call or online with transparent pricing. Whether for corporate use, school trips, or family travel, this nearby Urbania service guarantees convenience and satisfaction for every journey starting from Pimpri."
    },
    {
      "name": "Force Urbania Van Pimpri",
      "description": "Force Urbania Van Pimpri offers reliable and elegant transportation for group travel. The vans feature strong build quality, smooth suspension, and luxury seating designed for comfort. They’re perfect for weddings, corporate events, and sightseeing tours. Drivers are courteous and experienced in city and highway driving. Customers benefit from flexible timing, customized routes, and affordable pricing. With a focus on safety and comfort, Force Urbania Van Pimpri ensures a premium travel experience for all kinds of occasions in the Pimpri Chinchwad region."
    },
    {
      "name": "Premium Urbania Service PCMC",
      "description": "Premium Urbania Service PCMC caters to elite clients seeking an exceptional travel experience. The fleet includes top-tier Force Urbanias with leather interiors, ambient lighting, advanced climate control, and entertainment systems. Each journey is handled by uniformed chauffeurs who provide courteous and discreet service. Ideal for business executives, VIP guests, and luxury travelers, this service guarantees sophistication and reliability. Vehicles are maintained to the highest standards, ensuring a seamless journey across Pune or Maharashtra. With flexible packages and attentive customer support, Premium Urbania Service PCMC redefines comfort in every kilometer."
    }
  ],
  "tableData": [
    ["Urbania On Rent in Pimpri Chinchwad", "Urbania Hire Pimpri Chinchwad"],
    ["Force Urbania Rental Pimpri Chinchwad", "AC Urbania Pimpri"],
    ["Non AC Urbania Pimpri", "Luxury Urbania Pimpri"],
    ["16 Seater Urbania Pimpri", "17 Seater Urbania Pimpri"],
    ["Urbania Hire in Nigdi", "Urbania Hire in Wakad"],
    ["Urbania Hire in Bhosari", "Corporate Urbania Pimpri"],
    ["Wedding Urbania Pimpri", "Outstation Urbania Pimpri"],
    ["Affordable Urbania Pimpri Chinchwad", "Urbania Hire near Me Pimpri"],
    ["Force Urbania Van Pimpri", "Premium Urbania Service PCMC"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Urbania On Rent in Pimpri Chinchwad",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers spacious and reliable Urbania rental services in Pimpri Chinchwad, perfect for group travel and comfortable city rides."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vans are routinely serviced and thoroughly cleaned to ensure your safety and comfort."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Benefit from upfront rental rates with no hidden costs, inclusive of all taxes and fees."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental options tailored to meet your specific travel needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous drivers ensure a safe, punctual, and pleasant journey every time."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, inquiries, and travel arrangements."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your Urbania easily online or via phone, with prompt vehicle delivery anywhere in Pimpri Chinchwad."
  },
  {
    "WhyChooseheading": "Customer Satisfaction Commitment",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd is dedicated to providing reliable, comfortable, and hassle-free group travel experiences."
  }
]












  }

  
const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Urbania on rent in Pimpri Chinchwad?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides Urbania vehicles on rent in Pimpri Chinchwad, perfect for comfortable and convenient travel.',
  },
  {
    question: 'How can I book an Urbania for rent in Pimpri Chinchwad with Amruta Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 customer support team in Pimpri Chinchwad.',
  },
  {
    question: 'What amenities are available in the Urbania vehicles for rent in Pimpri Chinchwad?',
    answer: 'Our Urbania vehicles are equipped with comfortable seating, air conditioning, and essential safety features for a pleasant ride.',
  },
  {
    question: 'Are the drivers trained and experienced for Urbania hires in Pimpri Chinchwad?',
    answer: 'Absolutely. Our drivers are professional, courteous, and experienced in driving Urbania vehicles safely in Pimpri Chinchwad.',
  },
  {
    question: 'Can Urbania vehicles be hired for weddings, corporate events, and tours in Pimpri Chinchwad?',
    answer: 'Yes, these vehicles are ideal for weddings, corporate outings, airport transfers, and sightseeing tours in Pimpri Chinchwad.',
  },
  {
    question: 'Is the Urbania hire service available 24×7 in Pimpri Chinchwad?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for Urbania hire services in Pimpri Chinchwad to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for Urbania hires in Pimpri Chinchwad?',
    answer: 'All vehicles are thoroughly sanitized before every trip, and drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for Urbania hire in Pimpri Chinchwad?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the Urbania hire period in Pimpri Chinchwad?',
    answer: 'Yes, our 24×7 customer support team is available to assist you at any time during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Deshpande',
    feedback: 'The Urbania from Amruta Travels Pimpri Chinchwad was spacious and comfortable. The driver was punctual and very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Great experience with Amruta Travels. The Urbania was perfect for our corporate event in Pimpri Chinchwad.',
    rating: 5,
  },
];













































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Urbania On Rent in Pimpri Chinchwad",
  "description": "Affordable and luxury Urbania rental services in Pimpri Chinchwad by Amruta Travels Pvt. Ltd. Book Force Urbania AC and Non AC vans for corporate, wedding, and outstation trips in Nigdi, Wakad, Bhosari, and PCMC areas.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels Pvt. Ltd.",
    "url": "https://www.amrutatravelspvtltd.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pimpri Chinchwad, Maharashtra, India"
  },
  "serviceType": "Urbania Rental",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/urbania-rent-pimpri-chinchwad"
  }
};






  return (
    <div>
<Helmet>
  <title>Urbania On Rent in Pimpri Chinchwad | Affordable & Luxury Urbania Hire PCMC | Amruta Travels</title>
  <meta
    name="description"
    content="Affordable and luxury Urbania rental services in Pimpri Chinchwad by Amruta Travels Pvt. Ltd. Book Force Urbania AC and Non AC vans for corporate, wedding, and outstation trips in Nigdi, Wakad, Bhosari, and PCMC areas."
  />
  <meta
    name="keywords"
    content="Urbania On Rent in Pimpri Chinchwad, Urbania Hire Pimpri Chinchwad, Force Urbania Rental Pimpri Chinchwad, AC Urbania Pimpri, Non AC Urbania Pimpri, Luxury Urbania Pimpri, 16 Seater Urbania Pimpri, 17 Seater Urbania Pimpri, Urbania Hire in Nigdi, Urbania Hire in Wakad, Urbania Hire in Bhosari, Corporate Urbania Pimpri, Wedding Urbania Pimpri, Outstation Urbania Pimpri, Affordable Urbania Pimpri Chinchwad, Urbania Hire near Me Pimpri, Force Urbania Van Pimpri, Premium Urbania Service PCMC"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpimprichichwad;